<main id="main-content" class="main-content">
    <h2 class="form-header">1. Report Type</h2>

    <mat-card>
        <div class="title">Type of Report
            
        </div>
        <div class="text">
            {{ report_type_long || "--" }}
        </div>
        <div class="title">Does this assessment cover the full fire area or a phased area?
            
        </div>
        <div class="text">
            {{ report().initial_report_type || "--" }}
        </div>
    </mat-card>
</main>